import { useMutation, useQueryClient } from "@tanstack/react-query";

/**
 * useMutation that refreshes the given query keys after success.
 * `invalidate` is an array of keys, or a function (data, variables) => keys.
 */
const useInvalidatingMutation = (mutationFn, invalidate = [], options = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn,
    ...options,
    onSuccess: async (data, variables, context) => {
      const keys =
        typeof invalidate === "function"
          ? invalidate(data, variables)
          : invalidate;
      await Promise.all(
        keys
          .filter(Boolean)
          .map((queryKey) => qc.invalidateQueries({ queryKey })),
      );
      await options.onSuccess?.(data, variables, context);
    },
  });
};

export default useInvalidatingMutation;
